<div *ngIf="user; else anonymousUser" >
    <app-layout></app-layout>
</div>
<ng-template #anonymousUser>
   <app-login></app-login>
  </ng-template>